@charset "UTF-8";

/* src/app/content-editor/editor-sidebar/editor-sidebar.component.scss */
:host {
  display: flex;
  flex-direction: column;
  border-right: 0.5px solid var(--border);
  background: #fff;
  min-width: 0;
  min-height: 0;
  padding: 16px 0;
}
.sidebar-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 12px;
}
.sidebar-head span {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.03em;
  color: var(--text-secondary);
}
.sidebar-head-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}
.icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 0.5px solid var(--border);
  background: transparent;
  color: var(--text-secondary);
  border-radius: 8px;
  padding: 0;
  font-size: 12px;
  cursor: pointer;
  transition: 0.12s ease;
}
.icon-button.ghost {
  border-color: transparent;
  background: transparent;
}
.icon-button:hover {
  border-color: var(--border-hover);
  color: var(--text-primary);
}
.sidebar-search {
  position: relative;
  padding: 0 12px 12px;
}
.sidebar-search input {
  width: 100%;
  padding: 6px 10px;
  border: 0.5px solid var(--border);
  border-radius: 8px;
  background: var(--bg-secondary);
  font-size: 12px;
  color: var(--text-primary);
  outline: none;
}
.sidebar-search input:focus {
  border-color: var(--accent);
  background: #fff;
}
.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 12px;
  color: var(--text-secondary);
}
.template-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
}
.source-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}
.import-source-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 0.5px solid var(--border);
  background: transparent;
  color: var(--text-secondary);
  border-radius: 6px;
  padding: 4px 9px;
  font-size: 11px;
  cursor: pointer;
  transition: 0.12s ease;
}
.import-source-btn:hover {
  border-color: var(--border-hover);
  color: var(--text-primary);
}
.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
  margin-bottom: 0;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch .slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #ccd1d6;
  transition: 0.2s ease;
  border-radius: 999px;
}
.switch .slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: #fff;
  transition: 0.2s ease;
  border-radius: 50%;
}
.switch input:checked + .slider {
  background-color: var(--accent);
}
.switch input:checked + .slider:before {
  transform: translateX(14px);
}
.dropdown-results {
  position: absolute;
  top: 33px;
  left: 12px;
  right: 12px;
  border: 1px solid var(--border);
  border-radius: 0 0 12px 12px;
  border-top: 0;
  background: #fff;
  max-height: 240px;
  overflow: auto;
  z-index: 25;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.18) transparent;
}
.dropdown-results::-webkit-scrollbar {
  width: 8px;
}
.dropdown-results::-webkit-scrollbar-track {
  background: transparent;
}
.dropdown-results::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 999px;
  border: 2px solid #fff;
}
.result-item {
  padding: 9px 12px;
  font-size: 13px;
  color: var(--text-secondary);
  cursor: pointer;
  text-align: left;
}
.result-item:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}
.sidebar-panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
  overflow: hidden;
}
.sidebar-panel-head {
  display: flex;
  text-align: left;
  align-items: start;
  gap: 10px;
  padding: 6px 16px 10px;
}
.sidebar-title-group {
  min-width: 0;
  flex: 1;
}
.sidebar-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidebar-meta {
  font-size: 11px;
  color: var(--text-tertiary);
  text-transform: capitalize;
}
.sidebar-tree {
  min-height: 0;
  flex: 1;
  overflow: auto;
  padding: 0 0 16px;
  background: #fff;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.18) transparent;
}
.sidebar-tree::-webkit-scrollbar {
  width: 8px;
}
.sidebar-tree::-webkit-scrollbar-track {
  background: transparent;
}
.sidebar-tree::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 999px;
  border: 2px solid #fff;
}
.sidebar-tree::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.28);
}
::ng-deep .sidebar-tree app-tree .tree-node {
  margin-top: 0;
}
::ng-deep .sidebar-tree app-tree .toggle-btn {
  display: none;
}
::ng-deep .sidebar-tree app-tree .tree-item-container {
  margin-bottom: 5px;
}
::ng-deep .sidebar-tree:not(.dual-pane) app-tree .tree-item-container:has(.tree-item.expanded) {
  isolation: isolate;
  border: 1px solid rgba(0, 0, 0, 0.09);
  border-radius: 8px;
  padding: 2px;
  margin-left: 2px;
  margin-right: 2px;
}
::ng-deep .sidebar-tree:not(.dual-pane) app-tree .tree-item-container:has(.tree-item.expanded)::before {
  content: "";
  position: absolute;
  left: 6px;
  width: 106px;
  top: 3px;
  bottom: 3px;
  background:
    linear-gradient(
      180deg,
      var(--teal-bg) 0%,
      rgb(83, 163, 237) 100%);
  border-radius: 6px;
  z-index: -1;
  pointer-events: none;
}
::ng-deep .sidebar-tree app-tree .tree-item {
  border: 0;
  background: transparent;
  border-radius: 10px;
  padding: 4px 10px;
  color: var(--text-secondary);
  cursor: pointer;
}
::ng-deep .sidebar-tree app-tree .tree-item:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}
::ng-deep .sidebar-tree app-tree .tree-item.expanded:hover,
::ng-deep .sidebar-tree app-tree .children-container .tree-item:hover {
  background:
    linear-gradient(
      to right,
      transparent 110px,
      var(--bg-secondary) 110px);
}
::ng-deep .sidebar-tree app-tree .tree-item.editing-active,
::ng-deep .sidebar-tree app-tree .tree-item.sidebar-selected {
  color: var(--accent);
  font-weight: 600;
}
::ng-deep .sidebar-tree app-tree .item-tag-wrap {
  order: -1;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 94px;
  margin-right: 6px;
}
::ng-deep .sidebar-tree app-tree .item-tag {
  width: 100%;
  border: 0;
  border-radius: 4px;
  background: var(--purple-bg);
  color: var(--purple-text);
  font-size: 10px;
  font-weight: 700;
  text-transform: lowercase;
  text-align: center;
  padding: 2px 8px;
}
::ng-deep .sidebar-tree:not(.dual-pane) app-tree .tree-item.expanded .item-tag {
  background: var(--accent);
  color: #fff;
}
::ng-deep .sidebar-tree app-tree .tree-item.editing-active .item-tag,
::ng-deep .sidebar-tree app-tree .tree-item.sidebar-selected .item-tag {
  background: #b8d4f0;
  color: var(--accent);
}
::ng-deep .sidebar-tree app-tree .item-content {
  margin-left: 8px;
  max-width: none;
  font-size: 13px;
  line-height: 1.45;
}
::ng-deep .sidebar-tree app-tree .children-container {
  margin-left: 0;
  padding-left: 0;
}
::ng-deep .sidebar-tree app-tree .tree-item:hover .action-icon {
  opacity: 1;
}
::ng-deep .sidebar-tree app-tree .add-element-btn {
  width: 100%;
  border: 1px dashed var(--border);
  border-radius: 8px;
  background: transparent;
  color: var(--text-tertiary);
  padding: 10px;
  font-size: 12px;
  text-align: center;
}
::ng-deep .sidebar-tree app-tree .add-element-btn:hover {
  background: var(--accent-light);
  border-color: rgba(12, 68, 124, 0.25);
  color: var(--accent);
}
/*# sourceMappingURL=editor-sidebar.component.css.map */
